class ThemePredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-search-results]');
    this.closeButton = this.querySelector('[data-predictive-search-close]');
    this.abortController = null;

    this.input.addEventListener('input', this.debounce(this.onInput.bind(this), 250));
    this.input.addEventListener('focus', this.onInput.bind(this));
    this.input.addEventListener('keydown', this.onKeydown.bind(this));
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }
    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  onInput() {
    const searchTerm = this.input.value.trim();

    if (searchTerm.length < 2) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.input.focus();
    }
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  getSearchResults(searchTerm) {
    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    const url = new URL(this.dataset.predictiveSearchUrl, window.location.origin);
    url.searchParams.set('q', searchTerm);
    url.searchParams.set('section_id', 'predictive-search');
    url.searchParams.set('resources[type]', 'product,collection,page,article');
    url.searchParams.set('resources[limit]', '8');

    fetch(url.toString(), {
      signal: this.abortController.signal,
      headers: {
        Accept: 'text/html',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }

        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const section = html.querySelector('#shopify-section-predictive-search');

        if (!section) {
          this.close();
          return;
        }

        this.results.innerHTML = section.innerHTML;
        this.open();
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          this.close();
        }
      });
  }

  open() {
    this.setAttribute('open', '');
    this.toggleAttribute('data-entering', true);
    requestAnimationFrame(() => this.removeAttribute('data-entering'));
    this.input.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.removeAttribute('open');
    this.removeAttribute('data-entering');
    this.input.setAttribute('aria-expanded', 'false');
  }

  debounce(fn, wait) {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

if (!customElements.get('theme-predictive-search')) {
  customElements.define('theme-predictive-search', ThemePredictiveSearch);
}
